sn-long-content-type-2 {
  .sn-long-content-type-2__container {
    max-width: $media-desktop;
    margin: 0 auto;
    padding: 0 $spacing-xl $spacing-5xl;

    @include desktop {
      padding-top: 0;
      padding-bottom: $spacing-6xl;
    }

    @include desktop-lg {
      width: 75%;
      padding: 0 $spacing-3xl $spacing-7xl;
    }
  }

  .sn-long-content-type-2__content {
    min-width: 0;
  }

  .sn-long-content-type-2__html {
    max-width: 928px;
    margin: 0 auto;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: 700;
      color: $text-color-primary;
      margin: 0 0 $spacing-md;
      line-height: 1.3;

      @include desktop {
        font-size: map-get($font-sizes, 4xl);
      }

      &:not(:first-child) {
        margin-top: $spacing-3xl;
      }
    }

    p {
      color: $text-color-primary;
      margin: 0 0 $spacing-lg;
      line-height: 1.6;
    }

    ul,
    ol {
      margin: 0 0 $spacing-lg;
      padding-left: $spacing-xl;
      color: $text-color-primary;
      line-height: 1.6;
    }

    li {
      margin-bottom: $spacing-sm;
    }

    strong {
      font-weight: 700;
    }
  }
}
